import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';

declare var $: any;

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent implements OnInit {
  public user = AuthService.getUser();
  public hasSettings: boolean;
  public userPhoto = '../assets/img/avatars/' + this.user.photo;
  constructor() {
    //console.log(1);
  }

  ngOnInit() {
    this.hasSettings = AuthService.getUser().rolePermissions.find(x => x.module_id == 33) ? true : false;
  }

  public onLoggedOut() {
    AuthService.loggedOut();
  }

  setPhoto() {
    this.user = AuthService.getUser();
  }

}
